const strings = {
    general: {
        continue: "continuar",
        loremIpsum: 'Lorem ipsum',
        loremText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        buttonExample: 'Hello Store',
        successLoaded: 'Carregado com sucesso!',
        hello: 'Hello from store!'
    },
    errors: {
        genericError: "Erro Inesperado."
    }
}

export default strings;